// 标签管理
import http from "@/jslibs/axios/http";

// 标签列表
export const list = (data) => http.get("/v1/cms/UserLabel", data);

// 标签新增
export const add = (data) => http.post("/v1/cms/UserLabel", data);

// 标签编辑
export const edit = ({ uuid, ...data }) => http.put(`/v1/cms/UserLabel/${uuid}`, data);

// 标签删除
export const del = ({ uuid }) => http.delete(`/v1/cms/UserLabel/${uuid}`);

// 标签详情
export const detail = ({ uuid }) => http.get(`/v1/cms/UserLabel/${uuid}`);
